import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { MemberRoutingModule } from './member-routing.module';
import { AddMemberComponent } from './add-member/add-member.component';
import { MemberListComponent } from './member-list/member-list.component';
import {SharedModule} from './../shared/shared.module';
import { MemberDetailComponent } from './member-detail/member-detail.component';
import { MemberDisableComponent } from './member-disable/member-disable.component';
import { DisablePopupComponent } from './disable-popup/disable-popup.component';
import { EnablePopupComponent } from './enable-popup/enable-popup.component';
import { MemberInactiveComponent } from './member-inactive/member-inactive.component';
import { OnBoardingModule } from './../on-boarding/on-boarding.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,    
    MemberRoutingModule,
    SlimScrollModule,
    OnBoardingModule
  ],
  exports: [
    DisablePopupComponent
  ],
  declarations: [AddMemberComponent, MemberListComponent, MemberDetailComponent, MemberDisableComponent, DisablePopupComponent, EnablePopupComponent, MemberInactiveComponent]
})
export class MemberModule { }



// WEBPACK FOOTER //
// ./src/app/member/member.module.ts